import { CheckCircle, XCircle, X } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

export default function ImportResultModal({ result, onClose }) {
  if (!result) return null
  const { inserted = 0, skipped = 0, detail = [] } = result
  const show = detail.slice(0, 100)

  return (
    <AnimatePresence>
      <motion.div
        key="ov"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
        onClick={onClose}
        className="fixed inset-0 bg-black/45 backdrop-blur-[2px] z-40"
      />
      <motion.div
        key="dlg"
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 40, opacity: 0 }}
        transition={{ duration: 0.35, ease: 'easeOut' }}
        className="fixed z-50 inset-x-4 md:inset-x-0 mx-auto max-w-md w-full bg-white rounded-xl shadow-2xl flex flex-col"
      >
        <header className="flex items-center justify-between px-6 py-4 bg-gray-50 border-b">
          <h2 className="text-lg font-semibold">ผลการนำเข้า</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-red-500">
            <X size={20} />
          </button>
        </header>

        <div className="px-6 py-5 space-y-4 max-h-80 overflow-y-auto">
          <p className="flex items-center gap-2">
            <CheckCircle className="text-green-500" size={18} /> เพิ่มสำเร็จ:{' '}
            <b>{inserted}</b>
          </p>
          <p className="flex items-center gap-2">
            <XCircle className="text-red-500" size={18} /> ข้าม/เกิดข้อผิดพลาด:{' '}
            <b>{skipped}</b>
          </p>

          {skipped > 0 && (
            <>
              <h3 className="text-sm font-semibold mt-2">แถวที่ข้าม (สูงสุด 100)</h3>
              <div className="border rounded-lg overflow-auto">
                <table className="w-full text-xs">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="py-1 px-2 w-16 text-left">แถว</th>
                      <th className="py-1 px-2 text-left">สถานะ</th>
                      <th className="py-1 px-2 text-left">เหตุผล</th>
                    </tr>
                  </thead>
                  <tbody>
                    {show.map((d, i) => (
                      <tr key={i} className="odd:bg-white even:bg-gray-50">
                        <td className="py-1 px-2">{d.index}</td>
                        <td className="py-1 px-2">{d.status}</td>
                        <td className="py-1 px-2">{d.reason || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {detail.length > 100 && (
                <p className="text-xs text-center mt-1">… แสดงเพียง 100 แถวแรก …</p>
              )}
            </>
          )}
        </div>

        <footer className="flex justify-end px-6 py-4 border-t">
          <button
            onClick={onClose}
            className="bg-primary hover:bg-secondary text-white rounded-lg px-4 py-2 text-sm"
          >
            ปิด
          </button>
        </footer>
      </motion.div>
    </AnimatePresence>
  )
}
